'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PriceManagementService = function () {
  function PriceManagementService($http, appConfig) {
    "ngInject";

    (0, _classCallCheck3.default)(this, PriceManagementService);
    this.$http = $http;
    this.appConfig = appConfig;
  }

  (0, _createClass3.default)(PriceManagementService, [{
    key: 'getPriceFormula',
    value: function getPriceFormula(entityId) {
      return this.$http.get(this.appConfig.apiServiceBaseUri + 'api/pricelookup/formula/' + entityId);
    }
  }, {
    key: 'updatePrices',
    value: function updatePrices(entityId, prices, formula) {
      return this.$http.post(this.appConfig.apiServiceBaseUri + 'api/pricelookup/update/' + entityId + '?priceFormula=' + encodeURIComponent(formula), prices);
    }
  }]);
  return PriceManagementService;
}();

exports.default = PriceManagementService;


// WEBPACK FOOTER //
// ./client/app/components/priceManagement/priceManagement.service.js